import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {SelectionModel} from "@angular/cdk/collections";
import {EnumConnectionType, EnumStationFilterType, IStationData, IUser} from "../../../interfaces";
import {StoreSelectorsService} from "../../../services";
import {TranslocoService} from "@ngneat/transloco";
import { HttpClient } from '@angular/common/http';
import {Compbaser} from "../../../components/compbaser";
import {appData} from "../../../common";
import {catchError, debounceTime, map} from "rxjs/operators";
import {of, Subscription} from 'rxjs';

interface IMarker {
    station_business_id: string;
    color: string;
    label: string;
    lat: number;
    lng: number;
}

@Component({
    selector: 'app-station-map',
    templateUrl: './station-map.component.html',
    styleUrls: ['./station-map.component.scss']
})
export class StationMapComponent extends Compbaser implements OnInit, AfterViewInit, OnDestroy {

    m_stationSub$: Subscription;
    m_EnumConnectionSelected = EnumConnectionType.ALL;
    dataSource: MatTableDataSource<IStationData>;
    // m_businessId: Id;
    selection: SelectionModel<number>;
    center = {lat: 38, lng: -103};
    markerOptions: google.maps.MarkerOptions = {draggable: false};
    markerPositions: Array<IMarker> = [];
    zoom = 2;
    user: IUser;
    display?: google.maps.LatLngLiteral;
    dashboard: boolean;
    globalFilter = '';
    googleMapApiLoaded = false;
    stationData: IStationData;
    mapId: string;

    @Input()
    set filterByStation(i_filterByStation: IStationData) {
        this.stationData = i_filterByStation;
        if (i_filterByStation?.geo?.lat && i_filterByStation?.geo?.lon) {
            this.center = {lat: Number(i_filterByStation.geo.lat), lng: Number(i_filterByStation.geo.lon)};
        }
    }

    @Input()
    set setZoom(i_zoom) {
        this.zoom = i_zoom;
    }

    // markerPositions: google.maps.LatLngLiteral[] = [];
    // googleMapApiLoaded: Observable<boolean>;

    constructor(public storeSelector: StoreSelectorsService,
                protected override dialog: MatDialog,
                private translocoService: TranslocoService,
                private httpClient: HttpClient) {
        super();
        this.mapId = appData.googleMapId;
        this.stationsUpdate();
        
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                    this.dashboard = i_user.dashboard;
                })
        );

        if (!window.google || !window.google.maps || Object.keys(window.google.maps).length == 0) {
            this.cod(
                this.httpClient.jsonp(appData.googleMapUrl, 'callback')
                    .pipe(
                        map(() => true),
                        catchError(() => of(false))
                    ).subscribe((res: boolean) => {
                    if (!res) {
                        console.error("google map api is not connected!");
                    }
                    this.googleMapApiLoaded = res;
                })
            );
        } else {
            // this.googleMapApiLoaded =  new BehaviorSubject<boolean>(true);
            this.googleMapApiLoaded = true;
        }
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.stationsUpdate();
    }

    getOptions(m): google.maps.MarkerOptions {
        return {
            icon: `./assets/images/mapIcon.png`
        };
    }

    addMarker(event: google.maps.MapMouseEvent) {
    }

    removeMarker(index) {
        if (index === -1) return;
        this.markerPositions.splice(index, 1);
    }

    updateMarker(station_business_id: string, lat: number, lng: number, status, label, i_previousMarkerIndex: number) {
        if (this.stationData) {
            if (this.stationData.stat.$.station_business_id !== station_business_id)
                return;
        }
        let color;
        status === '1' ? color = 'up' : color = 'down';
        const newMarker = {
            station_business_id,
            color,
            label,
            lat,
            lng,
        };
        if (i_previousMarkerIndex === -1) {
            this.markerPositions.push(newMarker);
        } else {
            const prevMarker = this.markerPositions[i_previousMarkerIndex];
            if (newMarker.color === prevMarker.color) return;
            prevMarker.color = color;
        }
    }

    move(event: google.maps.MapMouseEvent) {
        this.display = event.latLng.toJSON();
    }

    openInfoWindow(marker) {
        // this.infoWindow.open(marker);
    }

    removeLastMarker() {
        // this.markerPositions.pop();
    }

    stationsUpdate() {
        this.unsubStationListener();
        let sourceStations: Array<IStationData> = [];
        this.m_stationSub$ = this.storeSelector
            .getStationsComplete(this.m_EnumConnectionSelected, EnumStationFilterType.NONE, null)
            .pipe(debounceTime(333))
            .subscribe((v: Array<IStationData>) => {
                sourceStations = v;
                this.updateStations(sourceStations);
                this.updateGeoLocation();
            });
    }

    unsubStationListener() {
        if (this.m_stationSub$)
            this.m_stationSub$.unsubscribe();
    }

    updateStations(sourceStations) {
        if (this.dataSource) {
            this.dataSource.data = sourceStations;
            return;
        }
        this.dataSource = new MatTableDataSource(sourceStations);
    }

    updateGeoLocation() {
        if (this.dataSource.data.length === 0)
            return this.markerPositions = [];
        this.dataSource.data.forEach((station: IStationData, c) => {
            const index = this.findGeoMarker(station.props.station_business_id);
            if (station?.geo?.lat && station?.geo?.lon) {
                const lt = Number(station.geo.lat) + (c * 0.01);
                const ln = Number(station.geo.lon);
                let connection = '';
                if (station.stat?.$?.version === '2') {
                    connection = station.stat.$.connection;
                } else {
                    connection = station.stat.$.socket;
                }
                this.updateMarker(station.stat.$.station_business_id, lt, ln, connection, station.stat.$.name, index);
            } else {
                this.removeMarker(index);
            }
        });
    }

    findGeoMarker(i_station_business_id): number {
        return this.markerPositions.findIndex((p_station) => {
            return p_station.station_business_id === i_station_business_id;
        });
    }

    override destroy() {
        super.destroy();
        this.unsubStationListener();
        //// @ts-expect-error: Let's ignore a single compiler error like this unreachable code
        // window.google = {};
    }
}

// sortColumn($event: Sort) {
//     console.log($event);
// }

// itemAllSelected() {
//     this.dataSource.data.forEach((a) => {
//         this.selection.select(a);
//     });
// }

// getMarkerIcon(m: marker) {
//     return `assets/screen_${m.color}.png`;
// }
